import Vue from "vue"

/**
 * ======================================================================
 *  State
 * ======================================================================
 */

const state = {
    tenant: "",
    activityStatus: "",
    status: "",
    showMe: true,
    myself: {},
    isAdmin: 0,
    usersOnline: [],
    members: [],
    groups: [],
    messages: [],
    chats: [],
    myself: {},
    participants: [],
    chatVisible: true,
    placeholder: "",
    unreadMessageCount: {}
}

/**
 * ======================================================================
 *  Mutations
 * ======================================================================
 */

const mutations = {
    setTenant: (state, tenant) => {
        state.tenant = tenant
    },
    setStatus: (state, status) => {
        state.status = status
    },
    async UpdateUsersOnline(state, payload) {
        if (state.isAdmin) {
            state.usersOnline = _.sortBy(payload, "full_name")
        } else {
            let online = payload.filter(ar => {
                let setVisible = _.get(ar.user_settings, "chat.showMe", false)
                return setVisible ? ar : !ar.roles.some(role => role.name == "super administrator")
            })
            state.usersOnline = _.sortBy(online, "full_name")
        }

        let offine = state.members.filter(ar => !payload.find(rm => rm.id == ar.id) && ar.id != state.myself.id)
        state.offlineMembers = _.sortBy(offine, "full_name")
    },
    setMembers: (state, members) => {
        if (state.isAdmin) {
            state.members = members
        } else {
            state.members = members.filter(ar => !ar.roles.some(role => role.name == "super administrator"))
        }
    },
    setGroups: (state, groups) => {
        state.groups = groups
    },
    setParticipants: (state, participants) => {
        state.participants = participants
    },
    setMyself: (state, myself) => {
        state.isAdmin = myself.roles.some(role => role.name == "super administrator")
        state.myself = myself
        state.showMe = _.get(myself.user_settings, "chat.showMe", false)
        state.status = _.get(myself.user_settings, "chat.status", "")
        state.activityStatus = _.get(myself.user_settings, "chat.activityStatus", "Active")
    },
    setActivityStatus: (state, status) => {
        state.activityStatus = status
    },
    setShowMe: (state, status) => {
        state.showMe = status
    },
    setMessages: (state, messages) => {
        state.messages = messages
    },
    setChatVisible: (state, visible) => {
        state.chatVisible = visible
    },
    setPlaceholder: (state, placeholder) => {
        state.placeholder = placeholder
    },
    setUnreadMessageCount: (state, payload) => {
        const {id, count} = payload
        Vue.set(state.unreadMessageCount, id, count)
    },
    setMessageCount: (state, count) => {
        state.unreadMessageCount = count
    },
    updateGroups: (state, payload) => {
        state.groups[payload.index] = payload.group
    }
}

/**
 * ======================================================================
 *  Actions
 * ======================================================================
 */

const actions = {
    setTenant(context, tenant) {
        context.commit("setTenant", tenant)
    },
    setStatus(context, status) {
        context.commit("setStatus", status)
    },
    setShowMe(context, payload) {
        context.commit("setShowMe", payload)
    },
    setActivityStatus(context, payload) {
        context.commit("setActivityStatus", payload)
    },
    usersOnline(context, payload) {
        context.commit("UpdateUsersOnline", payload)
    },
    setMembers(context, members) {
        context.commit("setMembers", members)
    },
    setGroups(context, groups) {
        context.commit("setGroups", groups)
    },
    setMyself(context, myself) {
        context.commit("setMyself", myself)
    },
    setMessages(context, messages) {
        context.commit("setMessages", messages)
    },
    setUnreadMessageCount: (context, payload) => {
        context.commit("setUnreadMessageCount", payload)
    },
    setMessageCount(context, count) {
        context.commit("setMessageCount", count)
    },
    setOfflineMembers(context, offline) {
        context.commit("setOfflineMembers", offline)
    },
    updateGroups(context, payload) {
        context.commit("updateGroups", payload)
        context.dispatch("setGroups", context.state.groups)
    },
    removeGroup(context, index) {
        let groups = context.state.groups
        groups.splice(index, 1)
        context.dispatch("setGroups", groups)
    }
}

/**
 * ======================================================================
 *  Getters
 * ======================================================================
 */

const getters = {
    tenant: state => state.tenant,
    usersOnline: state => state.usersOnline,
    messages: state => state.messages,
    myself: state => state.myself,
    getOfflineMembers: state => state.offlineMembers,
    unreadMessageCount: state => state.unreadMessageCount,
    unreadMessageTotal(state) {
        if (!_.isEmpty(state.unreadMessageCount)) {
            return Object.values(state.unreadMessageCount).reduce((a, b) => a + b)
        } else {
            let members = {}
            state.members.map(member => {
                members = Object.assign(members, {[member.id]: 0})
            })

            if (members.length > 0) {
                state.unreadMessageCount = members
                return Object.values(state.unreadMessageCount).reduce((a, b) => a + b)
            }

            return 0
        }
    },
    chatVisible: state => state.chatVisible,
    members: state => state.members,
    groups: state => state.groups,
    showMe: state => state.showMe,
    status: state => state.status,
    activityStatus: state => state.activityStatus,
    isAdmin: state => state.isAdmin
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
